import React from "react";
// import TestimoniesComp from "./TestimoniesComp";
const Testimonies = () => {
  return (
    <div className="container-fluid px-xl-5 mt-5">
      <div className="row">
        <h5 className="generalTextColor ourImpactAnimate">OUR TESTIMONIALS</h5>
        <div className="col-xl-3">
          <div className="">
            {/* <h4 className="pe-md-5 ourImpactAnimate">A few Comments About Us</h4> */}
          </div>
        </div>

        <div className="col-md-12 col-xl-9 d-flex flex-column flex-md-row flex-md-wrap justify-content-center align-items-center gap-md-4 mt-5">
          
            {/* <TestimoniesComp
              TestimoniesCompText="When my family was going through a tough time, Senidea EnableAll stepped in with food and school support for my children. I don’t know where we’d be today without them. They truly care."
              TestimoniesCompName="Grace O."
              TestimoniesCompLocation="Lagos"
            />
          
            <TestimoniesComp
              TestimoniesCompText="When my family was going through a tough time, Senidea EnableAll stepped in with food and school support for my children. I don’t know where we’d be today without them. They truly care."
              TestimoniesCompName="Grace O."
              TestimoniesCompLocation="Lagos"
            />
          
            <TestimoniesComp
              TestimoniesCompText="Volunteering with Senidea has been one of the most fulfilling things I’ve done. Seeing the impact we make firsthand — it reminds me how powerful kindness can be."
              TestimoniesCompName="Samuel N."
              TestimoniesCompLocation="Ibadan"
            />
         
                <TestimoniesComp 
                TestimoniesCompText = "Volunteering with Senidea has been one of the most fulfilling things I’ve done. Seeing the impact we make firsthand — it reminds me how powerful kindness can be."
                TestimoniesCompName = 'Samuel N.'
                TestimoniesCompLocation = "Ibadan"/>
            
            
                <TestimoniesComp 
                TestimoniesCompText = "Volunteering with Senidea has been one of the most fulfilling things I’ve done. Seeing the impact we make firsthand — it reminds me how powerful kindness can be."
                TestimoniesCompName = 'Samuel N.'
                TestimoniesCompLocation = "Ibadan"/>
          
            
                <TestimoniesComp 
                TestimoniesCompText = "Volunteering with Senidea has been one of the most fulfilling things I’ve done. Seeing the impact we make firsthand — it reminds me how powerful kindness can be."
                TestimoniesCompName = 'Samuel N.'
                TestimoniesCompLocation = "Ibadan"/> */}
            
        </div>
      </div>
    </div>
  );
};

export default Testimonies;
